<template>
  <div id="wrap" class="wrap_layout">
    <div class="container">
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <p class="tit mgt5">전자서명 등록</p>
          <p class="txt02">
            자필서명을 작성한 후 서명저장 클릭, 저장된 서명은 청약절차상 개별
            서류별 내용확인 후 적용됩니다.
          </p>
          <!-- 전자서명 영역 -->
          <div class="signature_wrap">
            <div class="btn_signature">
              <button type="button" class="btn_all_clear" @click="allClearPad">
                <span>초기화</span>
              </button>
            </div>
            <MblElcSignaturePad type="name" ref="namePad" :text="ptyNm" />
            <MblElcSignaturePad type="sign" ref="signPad" />
            <div class="btn_area masterBtn">
              <button type="button" class="btn_main" @click="saveSign">
                <span
                  >{{
                    getMasterButtonStatus() ? "다음으로 이동" : "성명/서명저장"
                  }}
                </span>
              </button>
            </div>
          </div>
          <!-- // 전자서명 영역 -->
          <div id="warning-message" class="txt02">
            가로 모드에선 진행하실 수 없습니다.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, inject, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import { flickingLayout, disableScroll } from "@/common/scrnCtrl";
import useDialog from "@/common/dialog";
import MblElcSignaturePad from "@/components/common/MblElcSignaturePad.vue";

export default {
  name: "sbcpDocSgn",
  components: {
    MblElcSignaturePad,
  },
  setup() {
    const router = useRouter();
    const axios = inject("axios");
    const dialog = useDialog();

    const namePad = ref(null);
    const signPad = ref(null);

    const ptyNm = ref("");

    disableScroll();

    const allClearPad = () => {
      namePad.value.undo();
      signPad.value.undo();
    };

    onMounted(async () => {
      await load();
      util.saveLog("009", "전자서명등록"); // 009 : 화면진입
      if (
        sessionUserInfo.rpsPdCd == "61139" ||
        sessionUserInfo.rpsPdCd == "61238" ||
        sessionUserInfo.rpsPdCd == "61239"
      ) {
        state.rtrnAnimInsYn = true;
      } else {
        state.rtrnAnimInsYn = false;
      }

      let ptyInfo = _.filter(
        sessionUserInfo.athPtyMapLst,
        (data) => data.cusNo == sessionUserInfo.cusNo
      );

      if (ptyInfo.length > 0) {
        ptyNm.value = ptyInfo[0].cusNm;
      } else {
        ptyNm.value = "성명";
      }
    });

    const state = reactive({
      currDate: util.formatDate(new Date(), "yyyymmdd"),
      rtrnAnimInsYn: false,
    });

    const saveSign = () => {
      let namePadData = namePad.value.signaturePad.saveSignature();
      let signPadData = signPad.value.signaturePad.saveSignature();

      if (namePadData.isEmpty || namePadData.data.length == 826) {
        dialog.alert("서명을 해주시길 바랍니다.").then(() => {
          flickingLayout(namePad.value.$el);
        });
        return false;
      }

      if (signPadData.isEmpty || signPadData.data.length == 826) {
        dialog.alert("서명을 해주시길 바랍니다.").then(() => {
          flickingLayout(signPad.value.$el);
        });

        return false;
      }

      if (namePadData.data.length < 5000 || signPadData.data.length < 5000) {
        dialog
          .alert(
            "정확한 성명, 서명이 입력되었는지 확인하시기 바랍니다. (단순 점, 선이 입력된 경우 진행이 불가할 수 있습니다.)"
          )
          .then(() => {
            if (namePadData.data.length < 5000) {
              flickingLayout(namePad.value.$el);
            } else {
              flickingLayout(signPad.value.$el);
            }
          });
        return false;
      }

      let param = {};

      param.base64Data = util.replaceAll(
        namePadData.data,
        "data:image/png;base64,",
        ""
      ); //서명 BASE64 데이터
      param.base64Data1 = util.replaceAll(
        signPadData.data,
        "data:image/png;base64,",
        ""
      ); //서명 BASE64 데이터
      param.prctrNo = sessionUserInfo.prctrNo;
      param.ctnsKdCd = sessionUserInfo.ctnsKdCd;
      param.orgCd = sessionUserInfo.orgCd;
      param.pcsCtnsSndReqId = sessionUserInfo.dataId;

      param.cusNo = sessionUserInfo.cusNo;
      param.dporYn = sessionUserInfo.dporYn;
      param.appnSroClmpeNm1 = sessionUserInfo.appnSroClmpeNm1;

      util.saveLog("003", "서명파일저장"); // 003 : 저장
      axios
        .json("/inspe/transferInspeSgnFile.do", param)
        .then(function (result) {
          var elcSgnYn = result.data.elcSgnYn;

          if (elcSgnYn == "Y") {
            //서명파일 업로드 성공
            router.push({ name: "sgnInpNdMainMttCnf" });
          } else {
            dialog.alert("전송이 실패하였습니다. 다시 진행해주시길 바랍니다.");
            window.location.reload();
          }
        });
    };

    const getMasterButtonStatus = () => {
      let result = false;

      if (namePad.value?.isSigned && signPad.value?.isSigned) {
        result = true;
      }

      return result;
    };

    return {
      state,
      allClearPad,
      namePad,
      signPad,
      saveSign,
      getMasterButtonStatus,
      load,
      sessionUserInfo,
      ptyNm,
    };
  },
};
</script>
<style scoped>
#warning-message {
  display: none;
}
@media only screen and (orientation: portrait) {
  #warning-message {
    display: none;
  }
}

@media only screen and (orientation: landscape) {
  .signature_wrap {
    display: none;
  }
  #warning-message {
    color: red;
    display: block;
  }
}
</style>
